var r = require("react-hook-form"),
  e = require("@hookform/resolvers"),
  o = function (e, o) {
    for (var s = {}; e.length;) {
      var n = e[0],
        t = n.code,
        i = n.message,
        a = n.path.join(".");
      if (!s[a]) if ("unionErrors" in n) {
        var u = n.unionErrors[0].errors[0];
        s[a] = {
          message: u.message,
          type: u.code
        };
      } else s[a] = {
        message: i,
        type: t
      };
      if ("unionErrors" in n && n.unionErrors.forEach(function (r) {
        return r.errors.forEach(function (r) {
          return e.push(r);
        });
      }), o) {
        var c = s[a].types,
          l = c && c[n.code];
        s[a] = r.appendErrors(a, o, s, t, l ? [].concat(l, n.message) : n.message);
      }
      e.shift();
    }
    return s;
  };
exports.zodResolver = function (r, s, n) {
  return void 0 === n && (n = {}), function (t, i, a) {
    try {
      return Promise.resolve(function (o, i) {
        try {
          var u = Promise.resolve(r["sync" === n.mode ? "parse" : "parseAsync"](t, s)).then(function (r) {
            return a.shouldUseNativeValidation && e.validateFieldsNatively({}, a), {
              errors: {},
              values: n.rawValues ? t : r
            };
          });
        } catch (r) {
          return i(r);
        }
        return u && u.then ? u.then(void 0, i) : u;
      }(0, function (r) {
        return {
          values: {},
          errors: r.isEmpty ? {} : e.toNestError(o(r.errors, !a.shouldUseNativeValidation && "all" === a.criteriaMode), a)
        };
      }));
    } catch (r) {
      return Promise.reject(r);
    }
  };
};